<template>
  <div>
    <div class="systemNav">
      <div class="systemNavWrap">
        <div @click="navState=item.nav" :class="{'isActive' : navState == item.nav}" v-for="item in pages">
          <span>
            <img :src="item.checkedIcon" v-if="navState == item.nav"/>
            <img :src="item.icon" v-show="navState != item.nav"/>
            {{item.name}}明细查询</span>
        </div>
      </div>
    </div>

    <div>
      <superDetail v-if="navState ==1" :auths="auths" :page="'积分'" :scoreType="1" key="score"/>
      <superDetail v-if="navState ==2" :auths="auths" :page="'星级'" :scoreType="2" key="star"/>
      <superDetail v-if="navState ==3" :auths="auths" :page="'信用'" :scoreType="3" key="pro"/>
    </div>
  </div>
</template>

<script>
  //韩金辰180718整理优化，180725合并三个子组件后再次优化本页面
  //除了子组件中的明细弹窗中的项目分交互分有可能有点问题，其他应该很稳了
  import superDetail from './E_scoreDetailed.vue'
  import utils from '../../common/js/util'

  export default {
    name: 'evaluationDetail',
    components: {
      superDetail,
    },
    data() {
      return {
        navState: 1,
        pages: [
          {
            nav: 1,
            name: '积分',
            icon: require('../../common/images/icon-jifen.png'),
            checkedIcon: require('../../common/images/icon-jifenActive.png')
          },
          {
            nav: 2,
            name: '星级',
            icon: require('../../common/images/icon-xingji.png'),
            checkedIcon: require('../../common/images/icon-xingjiActive.png')
          },
          {
            nav: 3,
            name: '信用',
            icon: require('../../common/images/icon-xinyong.png'),
            checkedIcon: require('../../common/images/icon-xinyongActive.png')
          }
        ],
        auths: []// 页面内权限
      }
    },
    mounted() {
      this.getAuth()
    },
    methods: {
      getAuth() {
        this.$http({
          method: "GET",
          url: "/rest/sysUser/getSysUserWebAuth",
          params: {
            webId: 21,
            sysUserId: sessionStorage.getItem("sysUserId")
          }
        }).then(res => {
          res.data.map(item => {
            this.auths.push(item.auth)
          })
        }).catch(err => {
          utils.myNotify(this, 'error', err.response, '查询失败，请稍后重试')
        })
      },
    },
  }
</script>
<style scoped>
  .is-in-pagination input {
    width: 30px;
  }

  .tableWrap > div {
    width: 160px;
    height: 30px;
    display: inline-block;
  }

  .tableWrap > span {
    margin-left: 40px;
    margin-right: 5px;
    color: #a3a3a3;
  }

  .systemNav {
    height: 70px;
    margin-top: 30px;
  }

  .systemNavWrap {
    padding-top: 20px;
    width: 650px;
    height: 70px;
    margin: 0 auto;
  }

  .systemNavWrap div span img {
    vertical-align: text-top;
    margin-right: 10px;
  }

  .systemNavWrap > div {
    width: 150px;
    height: 30px;
    vertical-align: middle;
    text-align: center;
    border: 1px solid transparent;
    border-radius: 20px;
    margin-right: 30px;
    margin-left: 30px;
    display: inline-block;
    color: #666666;
    font-size: 18px;
    cursor: pointer;
    line-height: 30px;
  }

  .isActive {
    border: 1px solid #2d2c7a !important;
    color: #2d2c7a !important;
    font-weight: bold;
  }
</style>



// WEBPACK FOOTER //
// src/views/Assessment/EvaluationDetail.vue